export default __webpack_public_path__ + "static/media/pin.4af5ced6.svg";